import React from "react";
import { useMantineTheme } from '@mantine/core';
import { safeValue } from "../../utils/globalFunctions";
import InputComponent from "../general/InputComponent";

const BarangNamaDibatalkan = ({ stateData }) => {

    const theme = useMantineTheme();

    return (
        <React.Fragment>
            <InputComponent
                stateId={stateData.data.id}
                stateWithAsterisk={stateData.data.withAsterisk}
                stateLabelFullWidth={true}
                stateLabel={stateData.data.label}
                stateDescription=''
                statePlaceHolder={stateData.data.placeholder}
                stateReadOnly={true}
                stateValue={safeValue(stateData.data.value, '')}
                stateError={stateData.data.error}
                stateStylesInput={{
                    backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
                }}
            />
        </React.Fragment>
    )
}

export default BarangNamaDibatalkan;